import { createStore } from "vuex";
import bootstrap from "bootstrap/dist/js/bootstrap.min.js";
import { auth } from "./auth.module";
import { reset } from "./reset.module";
import { profile } from "./profile.module";
import { farmacias } from "./farmacias.module";
import { utilidades } from "./utilidades.module";

export default createStore({
  state: {
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    color: "",
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showMain: true,
    navbarFixed:
      "position-sticky blur shadow-blur left-auto top-1 z-index-sticky px-0 mx-4",
    absolute: "position-absolute px-4 mx-0 w-100 z-index-2",
    bootstrap,
  },
  modules: {
    auth,
    reset,
    profile,
    farmacias,
    utilidades
  },
  mutations: {
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");
      if (!sidenav_show) return;

      const shouldPin = sidenav_show.classList.contains("g-sidenav-hidden");
      sidenav_show.classList.toggle("g-sidenav-hidden", !shouldPin);
      sidenav_show.classList.toggle("g-sidenav-pinned", shouldPin);
      state.isPinned = shouldPin;
    },
    setSidenavState(state, isPinned) {
      const sidenav_show = document.querySelector(".g-sidenav-show");
      if (!sidenav_show) return;

      sidenav_show.classList.toggle("g-sidenav-hidden", !isPinned);
      sidenav_show.classList.toggle("g-sidenav-pinned", isPinned);
      state.isPinned = isPinned;
    },
    cardBackground(state, payload) {
      state.color = payload;
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
    toggleEveryDisplay(state) {
      state.showNavbar = !state.showNavbar;
      state.showSidenav = !state.showSidenav;
    },
    toggleHideConfig(state) {
      state.hideConfigButton = !state.hideConfigButton;
    },
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    },
    setCardBackground({ commit }, payload) {
      commit("cardBackground", payload);
    },
  },
  getters: {},
});
